import {
  computed,
  Directive,
  effect,
  inject,
  input,
  TemplateRef,
  ViewContainerRef,
} from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { UserProvider } from '../services';

@Directive({
  selector: '[libHasPermissions]',
})
export class HasPermissionsDirective {
  /**
   * Required permissions, a single one or a list
   */
  readonly libHasPermissions = input<string | string[]>([]);

  /**
   * Template rendered when the user has the permissions
   */
  private readonly templateRef = inject(TemplateRef);

  /**
   * Container where the template is rendered
   */
  private readonly viewContainer = inject(ViewContainerRef);

  /**
   * Source of the current user permissions
   */
  private readonly userProvider = inject(UserProvider);

  /**
   * Current user permissions
   */
  private readonly userPermissions = toSignal(
    this.userProvider.permissionList$,
    { initialValue: this.userProvider.currentPermissionList },
  );

  /**
   * Whether the user has at least one of the required permissions
   */
  private readonly hasPermission = computed(() => {
    const required = [this.libHasPermissions()].flat();
    if (required.length === 0) return true;
    const userPermissions = this.userPermissions() ?? [];
    return userPermissions.some((p) => required.includes(p));
  });

  constructor() {
    effect(() => {
      this.viewContainer.clear();
      if (this.hasPermission()) {
        this.viewContainer.createEmbeddedView(this.templateRef);
      }
    });
  }
}
